<template>
<div class="centered-container">
    <!-- 根据 emptyImageType 切换 listempty / listempty2，与 PC 端 EmptyImgPc 语义对齐 -->
    <img
      :src="resolvedEmptyImage"
      alt="空数据提示图片"
      class="centered-image"
      :style="{ maxWidth: imageMaxWidthRem }"
    >
    <p class="centered-text">{{ emptyDataText }}</p>
</div>
</template>

<script>
// 默认空列表插画（与 emptyImgPc、历史 emptyImgh5 一致）
import emptyimgDefault from "@/assets/img/listempty.png";
// 第二套空状态插画（listempty2）
import emptyimgList2 from "@/assets/img/listempty2.png";

// 空状态插画类型，避免魔法数字
const EMPTY_IMAGE_TYPE = {
  DEFAULT: 1,
  LIST_EMPTY_2: 2
};

export default {
    name: 'emptyImgh5',
    props: {
        emptyDataText: {
            type: String,
            default: '列表暂无数据'
        },
        // 1：listempty.png；2：listempty2.png
        emptyImageType: {
            type: Number,
            default: EMPTY_IMAGE_TYPE.DEFAULT
        }
    },
    computed: {
        resolvedEmptyImage() {
            if (this.emptyImageType === EMPTY_IMAGE_TYPE.LIST_EMPTY_2) {
                return emptyimgList2;
            }
            return emptyimgDefault;
        },
        // listempty2 在 H5 上使用较宽的 max-width
        imageMaxWidthRem() {
            if (this.emptyImageType === EMPTY_IMAGE_TYPE.LIST_EMPTY_2) {
                return '4.167rem';
            }
            return '2.083rem';
        }
    }
}
</script>

<style lang="scss" scoped>
.centered-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 4.167rem;
}

.centered-image {
    display: block;
    margin: 0 auto;
}

.centered-text {
    margin-top: .208rem;
    font-size: .292rem;
    color: #ccc;
}
</style>
